import React from 'react';
import { createSelector } from 'reselect';

import { getState } from '../index';

import PageContainer from '../views/PageContainer';
import LoadingContainer from '../views/Loading/LoadingContainer';
import LoginContainer from '../views/Login/LoginContainer';
import NotFoundContainer from '../views/NotFound/NotFoundContainer';

const getLocation = state => state.global;

const pageComponentForLocation = (state) => {
  const page = state.page;
  switch (page) {
    case 'LOGIN':
      return <LoginContainer />;
    case 'PAGE':
      return <PageContainer getState={getState} />;
    case '@@redux-first-router/NOT_FOUND':
      return <NotFoundContainer />;
    default:
      return <LoadingContainer />;
  }
};

export const getPageComponent = createSelector([getLocation], pageComponentForLocation);



// WEBPACK FOOTER //
// ./src/selectors/pageComponentSelector.js